export default __webpack_public_path__ + "static/media/Three.0e959a89.svg";